import { useState } from "react";
import { SayfaBasligi, Sekmeler } from "@koclukpanel/ui";
import { Analizim } from "./Analizim";
import { HataDefterim } from "./HataDefterim";
import { Konularim } from "./Konularim";
import type { AnalizHedefi } from "./Kabuk";

/**
 * ANALİZ BÖLÜMÜ — sürüm 9b (eski "Gelişim" sekmesi)
 *
 * Alt şeritteki adı müşterinin listesinden: "Analiz raporlama". Üç görünüm
 * aynı soruya ("nerede eksiğim var") üç açıdan bakıyor:
 *
 *   Analiz        haftalık doğru/yanlış/süre (UNİKOÇ "Analiz ve Raporlama")
 *   Konu Takibi   tamamlanan konular (müşteri listesi: "Konu Takip")
 *   Hata defterim yanlışların kaydı
 *
 * KONU TAKİBİ NEDEN BURADA, PROGRAM'DA DEĞİL: Program "bu hafta ne
 * yapacağım" sorusunun ekranı ve haftaya bağlı; konu takibi haftadan
 * bağımsız, birikimli bir ilerleme ("hangi konuları bitirdim"). Analizle
 * aynı yerde durması, öğrencinin haftalık sonucu konu durumuyla birlikte
 * okumasını sağlıyor — koçla haftalık değerlendirme de bu ikisi üzerinden.
 * Masaüstü yan menüsünde ayrıca kendi girdisi var (UNİKOÇ'taki gibi).
 *
 * Ödüller 9b'de buradan ÇIKTI: kendi alt şerit girdisi var (Kabuk.tsx).
 *
 * Görünüm dışarıdan da sürülebiliyor (`gorunum`/`onGorunum`): yan menüdeki
 * "Konu Takibi" doğrudan o görünümü açıyor.
 */
const GORUNUMLER = [
  { deger: "analiz", etiket: "Analiz" },
  { deger: "konular", etiket: "Konu Takibi" },
  { deger: "hata", etiket: "Hata defterim" },
] as const satisfies readonly { deger: AnalizHedefi; etiket: string }[];

const ACIKLAMA: Record<AnalizHedefi, string> = {
  analiz: "Haftalık çözdüğün soruları ve süreni gör, gelişimini izle.",
  konular: "Hangi konuları bitirdin, hangileri sırada — ders ders.",
  hata: "Yanlışlarını kaydet, tekrar zamanı gelince karşına çıksın.",
};

export function Gelisim({
  gorunum: disGorunum,
  onGorunum,
}: {
  gorunum?: AnalizHedefi;
  onGorunum?: (g: AnalizHedefi) => void;
} = {}) {
  const [icGorunum, setIcGorunum] = useState<AnalizHedefi>("analiz");
  const gorunum = disGorunum ?? icGorunum;
  const sec = (g: AnalizHedefi) => {
    setIcGorunum(g);
    onGorunum?.(g);
  };
  return (
    <div className="flex flex-1 flex-col gap-4 p-4 lg:px-4 lg:py-2">
      <SayfaBasligi baslik="Analiz" aciklama={ACIKLAMA[gorunum]} ikon="analiz">
        <Sekmeler
          gorunum="hap"
          etiket="Analiz görünümü"
          sekmeler={GORUNUMLER}
          secili={gorunum}
          onSec={sec}
        />
      </SayfaBasligi>
      {/*
        h1 → h2 → h3: analiz bileşenleri (`DetayliAnaliz`) bölüm başlıklarını h3
        yazıyor; araya h2 girmeyince axe heading-order ihlal ediyordu (GCP
        06.10.2026). Başlık görünmez — görünür karşılığı seçili hap.
      */}
      <h2 className="sr-only">{GORUNUMLER.find((g) => g.deger === gorunum)?.etiket}</h2>
      {gorunum === "analiz" ? (
        <Analizim />
      ) : gorunum === "konular" ? (
        <Konularim />
      ) : (
        <HataDefterim />
      )}
    </div>
  );
}
